import { Alert, AlertTitle, Typography } from "@mui/material";
import dayjs from "dayjs";
import { isEmpty } from "lodash";
import { useUserInfo } from "../../utils/security";
import { formatCurrency } from "../../utils/numbers";

const RecurringTransactionAlert = ({ count, amount, date, frequency, currencyCode }) => {
    const { userInfo } = useUserInfo();

    if (isEmpty(date)) {
        return null;
    }

    count = Math.min(count, 100);

    let d = dayjs(date);
    let dates = [];
    for (let i = 0; i < count; i++) {
        dates.push(d.format(userInfo.dateFormat || "DD.MM.YYYY"));
        d = d.add(1, frequency);
    }

    const total = count * amount || 0;

    return (
        <Alert severity="info">
            <AlertTitle>Opakující se transakce</AlertTitle>
            <Typography gutterBottom>
                Bude vytvořeno {count || 0} transakcí s daty: {dates.join(", ")}
            </Typography>
            {isNaN(total) ? null : (
                <Typography gutterBottom>
                    Celková částka {count || 0} transakcí:{" "}
                    {formatCurrency(
                        total,
                        currencyCode,
                        userInfo.currencies,
                        2,
                        userInfo.decimalDelimiter,
                        userInfo.thousandDelimiter
                    )}
                </Typography>
            )}
        </Alert>
    );
};

export default RecurringTransactionAlert;
